import { render, staticRenderFns } from "./mockup4.vue?vue&type=template&id=0094a8ec&scoped=true"
import script from "./mockup4.vue?vue&type=script&lang=js"
export * from "./mockup4.vue?vue&type=script&lang=js"
import style0 from "./mockup4.vue?vue&type=style&index=0&id=0094a8ec&prod&scoped=true&lang=css"
import style1 from "./mockup4.vue?vue&type=style&index=1&id=0094a8ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0094a8ec",
  null
  
)

export default component.exports